/**
 * SideBar component
 * @author Carlos Romera <cromera@adasasistemas.com>
 */

// Library
import React, { ReactNode } from 'react';

// CSS Style for this module
import styles from './sidebar.module.scss';

/**
 * Interface for SideBar props
 */
interface SideBarProps {
	isOpened?: boolean;
	customizeClassName: string;
	children: ReactNode;
}

export const SideBar = ({
	isOpened = true,
	customizeClassName,
	children,
}: SideBarProps): React.ReactElement => {
	return (
		<div className={styles[`${customizeClassName}-${isOpened ? 'open' : 'closed'}`]}>
			{children}
		</div>
	);
};
